import { pick } from "lodash";
import moment from "moment";

const [PLAYER_WIDTH, PLAYER_HEIGHT] = ["854", "480"];
const IFRAME_YT_API = "https://www.youtube.com/iframe_api";
const EXPIRE_MONTH = 13;

export class OverlayVideoController {
  public static $inject: string[] = [
    "$cookies",
    "$location",
    "$rootScope",
    "$timeout",
    "$window"
  ];
  public player: any;
  public playerReady = false;
  public videoDone = false;
  public overlay: HTMLElement;
  public videoId: string;
  public paths: string[];
  public cookieName: string;
  public cookie: string;
  public displayable = false;

  constructor(
    private $cookies: angular.cookies.ICookiesService,
    private $location: ng.ILocationService,
    private $rootScope: ng.IRootScopeService,
    private $timeout: ng.ITimeoutService,
    private $window: ng.IWindowService
  ) {}

  public $onInit() {
    if (!this.$window.configOverlayVideo) {
      return;
    }

    const { videoId = undefined, paths = [] } = <any>pick(this.$window.configOverlayVideo, ["videoId", "paths"]) || {};
    this.videoId = videoId;
    this.paths = paths.split(";");

    if (this.videoId && this.paths.length) {
      this.cookieName = `overlay_${this.videoId}`;
      this.cookie = this.$cookies.get(this.cookieName);
      this.$rootScope.$on("$stateChangeSuccess", (_, toState) => this.setDisplayableByPath(toState.url));
      this.$rootScope.$watch(
        () => this.displayable,
        value => {
          if (value) {
            this.openOverlay();
          } else {
            this.stopVideo();
          }
        }
      );
    }

    this.setDisplayableByPath(this.$location.path());
  }

  public stopVideo() {
    if (this.player) {
      this.player.stopVideo();
    }
  }

  public openOverlay() {
    this.overlay = document.querySelector("#overlay_video");
    if (this.playerReady) {
      this.overlay.style.display = "flex";
      this.player.playVideo();
    } else {
      this.loadYTIframeApi(() => {
        this.overlay.style.display = "flex";
        this.player.playVideo();
      });
    }
  }

  public closeOverlay() {
    this.overlay.style.display = "none";
    this.setCookieOverlayVideo();
    this.stopVideo();
  }

  private setDisplayableByPath(path: string) {
    this.cookie = this.$cookies.get(this.cookieName);
    this.displayable = this.videoId && this.paths.includes(path) && !this.cookie;
  }

  private loadYTIframeApi(callback = undefined) {
    const scriptAPIYTIframe = document.createElement("script");

    scriptAPIYTIframe.src = IFRAME_YT_API;
    const firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode.insertBefore(scriptAPIYTIframe, firstScriptTag);

    this.$window.onYouTubeIframeAPIReady = () => {
      this.player = new this.$window.YT.Player("player", {
          videoId: this.videoId,
          height: PLAYER_HEIGHT,
          width: PLAYER_WIDTH,
          events: {
              "onReady": () => this.onPlayerReady(callback),
              "onStateChange": event => this.onPlayerStateChange(event)
          }
      });
    };
  }

  private onPlayerReady(callback = undefined) {
    this.playerReady = true;
    if (callback) {
      callback();
    }
  }

  private onPlayerStateChange(event) {
    if (event.data === this.$window.YT.PlayerState.ENDED && !this.videoDone) {
      this.$timeout(() => this.closeOverlay(), 1000);
      this.videoDone = true;
    }
  }

  private setCookieOverlayVideo() {
    this.$cookies.put(this.cookieName, "true", {
      path: "/",
      domain: window.location.hostname,
      expires: moment().add(EXPIRE_MONTH, "months").toISOString(),
      samesite: "lax"
    });
  }
}
